// eslint-disable-next-line import/prefer-default-export
export const sampleFieldsDefinitions = {
  DataHoraAmostragem: {
    name: 'engineering.sample-date',
    minValue: '1950-01-01T00:00Z',
    maxValue: null,
    isDate: true,
  },
  H2: {
    name: 'fields.engineering.chromatography.insert-sample.h2',
    minValue: 0,
    maxValue: 1000000,
  },
  CH4: {
    name: 'fields.engineering.chromatography.insert-sample.ch4',
    minValue: 0,
    maxValue: 1000000,
  },
  C2H6: {
    name: 'fields.engineering.chromatography.insert-sample.c2h6',
    minValue: 0,
    maxValue: 1000000,
  },
  C2H4: {
    name: 'fields.engineering.chromatography.insert-sample.c2h4',
    minValue: 0,
    maxValue: 1000000,
  },
  C2H2: {
    name: 'fields.engineering.chromatography.insert-sample.c2h2',
    minValue: 0,
    maxValue: 1000000,
  },
  CO: {
    name: 'fields.engineering.chromatography.insert-sample.co',
    minValue: 0,
    maxValue: 1000000,
  },
  CO2: {
    name: 'fields.engineering.chromatography.insert-sample.co2',
    minValue: 0,
    maxValue: 1000000,
  },
  N2: {
    name: 'fields.engineering.chromatography.insert-sample.n2',
    minValue: 0,
    maxValue: 1000000,
  },
  O2: {
    name: 'fields.engineering.chromatography.insert-sample.o2',
    minValue: 0,
    maxValue: 1000000,
  },
  LimiteDeteccaoAnaliticaPadrao: {
    name:
      'fields.engineering.chromatography.insert-sample.standard-analytical-detection-limit',
    minValue: 0,
    maxValue: 1000000,
  },
  FatorAcuracia: {
    name:
      'fields.engineering.chromatography.insert-sample.accuracy-factor',
    minValue: 0,
    maxValue: 1000000,
  },
  LimiteDeteccaoAnaliticaH2: {
    name:
      'fields.engineering.chromatography.insert-sample.analytical-detection-limit',
    textParams: {
      chemicalElement: 'H₂',
    },
    minValue: 0,
    maxValue: 1000000,
  },
  LimiteDeteccaoAnaliticaCH4: {
    name:
      'fields.engineering.chromatography.insert-sample.analytical-detection-limit',
    textParams: {
      chemicalElement: 'CH₄',
    },
    minValue: 0,
    maxValue: 1000000,
  },
  LimiteDeteccaoAnaliticaC2H6: {
    name:
      'fields.engineering.chromatography.insert-sample.analytical-detection-limit',
    textParams: {
      chemicalElement: 'C₂H₆',
    },
    minValue: 0,
    maxValue: 1000000,
  },
  LimiteDeteccaoAnaliticaC2H4: {
    name:
      'fields.engineering.chromatography.insert-sample.analytical-detection-limit',
    textParams: {
      chemicalElement: 'C₂H₄',
    },
    minValue: 0,
    maxValue: 1000000,
  },
  LimiteDeteccaoAnaliticaC2H2: {
    name:
      'fields.engineering.chromatography.insert-sample.analytical-detection-limit',
    textParams: {
      chemicalElement: 'C₂H₂',
    },
    minValue: 0,
    maxValue: 1000000,
  },
  LimiteDeteccaoAnaliticaCO: {
    name:
      'fields.engineering.chromatography.insert-sample.analytical-detection-limit',
    textParams: {
      chemicalElement: 'CO',
    },
    minValue: 0,
    maxValue: 1000000,
  },
  LimiteDeteccaoAnaliticaCO2: {
    name:
      'fields.engineering.chromatography.insert-sample.analytical-detection-limit',
    textParams: {
      chemicalElement: 'CO₂',
    },
    minValue: 0,
    maxValue: 1000000,
  },
  LimiteDeteccaoAnaliticaN2: {
    name:
      'fields.engineering.chromatography.insert-sample.analytical-detection-limit',
    textParams: {
      chemicalElement: 'N₂',
    },
    minValue: 0,
    maxValue: 1000000,
  },
  LimiteDeteccaoAnaliticaO2: {
    name:
      'fields.engineering.chromatography.insert-sample.analytical-detection-limit',
    textParams: {
      chemicalElement: 'O₂',
    },
    minValue: 0,
    maxValue: 1000000,
  },
  TemperaturaAmbiente: {
    name:
      'fields.engineering.chromatography.insert-sample.ambient-temperature',
    minValue: -30,
    maxValue: 50,
  },
  TemperaturaAmostra: {
    name:
      'fields.engineering.chromatography.insert-sample.sample-temperature',
    minValue: -30,
    maxValue: 200,
  },
  TipoAmostra: {
    name:
      'fields.engineering.chromatography.insert-sample.sample-type',
  },
  DataHoraAnalise: {
    name:
      'fields.engineering.chromatography.insert-sample.analysis-date',
    minValue: '1950-01-01T00:00Z',
    maxValue: null,
    isDate: true,
  },
  LocalAmostragem: {
    name:
      'fields.engineering.chromatography.insert-sample.transformer-oil-sampling-location',
    maxLength: 500,
  },
  UmidadeRelativaAr: {
    name:
      'fields.engineering.chromatography.insert-sample.air-relative-humidity',
    minValue: 0,
    maxValue: 100,
  },
  Observacao: {
    name: 'fields.general.observations',
    maxLength: 500,
  },
};
